import { useRef, useState } from "react";

/**
 * A promise-based prompt: `askInput(config)` opens the input modal and resolves with what was typed
 * (or null when cancelled). The modal itself is rendered by the caller from `inputOpen`/`inputCfg`.
 */
export function useInputModal() {
  const inputResolveRef = useRef<((v: string|null)=>void)|null>(null);
  const [inputOpen, setInputOpen] = useState(false);
  const [inputCfg, setInputCfg] = useState<{ title?: string; label?: string; placeholder?: string; initialValue?: string; textarea?: boolean; okText?: string }>({});
  function askInput(cfg: { title?: string; label?: string; placeholder?: string; initialValue?: string; textarea?: boolean; okText?: string }): Promise<string|null> {
    setInputCfg(cfg);
    setInputOpen(true);
    return new Promise((resolve) => { inputResolveRef.current = resolve; });
  }
  function closeInput(val: string|null) {
    setInputOpen(false);
    const r = inputResolveRef.current; inputResolveRef.current = null;
    if (r) r(val);
  }
  return { inputOpen, inputCfg, askInput, closeInput };
}
